var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dynamicTags),function(tag){return _c('el-tag',{key:tag.name,staticClass:"tag-class",attrs:{"closable":"","disable-transitions":false,"type":tag.type},on:{"close":function($event){return _vm.handleClose(tag)}},nativeOn:{"click":function($event){return _vm.onClick(tag)}}},[_vm._v("\n    "+_vm._s(tag.name)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b51f650","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/component/HeaderTag.vue
// module id = null
// module chunks = 